import {Route} from '@angular/router';
import {InitialDataResolver} from 'app/app.resolvers';
import {LayoutComponent} from './layout/layout.component';
import {ConfigResolvers} from './core/utils/config.resolvers';

export const appRoutes: Route[] = [

    // Redirect empty path to '/dashboard'
    {path: '', pathMatch: 'full', redirectTo: 'account/campaigns'},

    // Auth routes (guest)
    {
        path: 'auth',
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        resolve: {
            config: ConfigResolvers,
        },
        children: [
            {
                path: '',
                redirectTo: 'sign-in',
                pathMatch: 'full'
            },
            {
                path: 'verify/email/:hash',
                loadChildren: () => import('app/modules/auth/confirmation-required/confirmation-required.module').then(m => m.AuthConfirmationRequiredModule)
            },
            {
                path: 'forgot-password',
                loadChildren: () => import('app/modules/auth/forgot-password/forgot-password.module').then(m => m.AuthForgotPasswordModule)
            },
            {
                path: 'password/recovery/:hash',
                loadChildren: () => import('app/modules/auth/reset-password/reset-password.module').then(m => m.AuthResetPasswordModule)
            },
            {
                path: 'sign-in',
                loadChildren: () => import('app/modules/auth/sign-in/sign-in.module').then(m => m.AuthSignInModule)
            },
            {
                path: 'sign-up',
                loadChildren: () => import('app/modules/auth/sign-up/sign-up.module').then(m => m.AuthSignUpModule)
            }
        ]
    },

    // Admin routes
    {
        path: '',
        component: LayoutComponent,
        resolve: {
            initialData: InitialDataResolver,
            config: ConfigResolvers,
        },
        data: {
            layout: 'dense'
        },
        children: [
            {
                path: '',
                loadChildren: () => import('app/modules/account/account.module').then(m => m.AccountModule)
            },
            {
                path: '',
                loadChildren: () => import('app/modules/backend/backend.module').then(m => m.BackendModule)
            },
            {
                path: '',
                loadChildren: () => import('app/modules/control/control.module').then(m => m.ControlModule)
            }
        ]
    },

    // 404 & Catch all
    {
        path: '404-not-found',
        pathMatch: 'full',
        data: {
            layout: 'empty'
        },
        loadChildren: () => import('app/modules/errors/errors.module').then(m => m.ErrorsModule)
    },
    {path: '**', redirectTo: '404-not-found'},
];
